// frontend_react/src/components/Layout.jsx

import DashboardLayout from './DashboardLayout';
import { Outlet } from 'react-router-dom';

export default function Layout() {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
}
